import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { NoData } from "src/shared/components/tables/no-data";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TablePagination,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { InventoryPermissions } from "src/constants/permissions";
import { oneBranchHasPermission } from "src/utils";
import { useGetPoRequests } from "src/api/inventory/reorder";
import SecondaryChip from "src/shared/components/secondary-chip";
import TableActions from "./table-actions";

const EntriesList = () => {
  const { t } = useTranslation("purchasing");
  const { t: inventoryT } = useTranslation("inventory");
  const { t: generalT } = useTranslation("general");

  const [pageNumber, setPageNumber] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const navigate = useNavigate();

  const navigateToViewEntry = (id: any) => {
    navigate(`/inventory/production/${id}`);
  };

  const HeadText = [
    generalT("reference"),
    t("branch"),
    t("supplier"),
    t("items"),
    inventoryT("expectedTotal"),
    generalT("status"),
    inventoryT("sentStatus"),
    generalT("actions"),
  ];

  // APIS
  const { data, isFetching, refetch } = useGetPoRequests({
    page: pageNumber + 1,
  });

  const addPermission = oneBranchHasPermission(
    InventoryPermissions.addUnitCostAdjustment
  );

  const emptyDataArr = data?.data.length === 0;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  useEffect(() => {
    if (!!data) {
      setTotal(data.meta?.total as number);
    }
  }, [data]);

  return (
    <Stack spacing={3} maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Stack
          direction={"row"}
          gap={2}
          flexWrap={"wrap"}
          mt={{ xs: 2, md: 5 }}
        >
          {/* {addPermission && (
             
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={navigateToAddPage}
                size="small"
              >
                {inventoryT("addAdjustments")}
              </Button>
          )} */}
        </Stack>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {HeadText.map((item) => (
                <TableCell
                  key={item}
                  align={"center"}
                  sx={{
                    bgcolor: "#F9FAFB",
                  }}
                >
                  <Typography
                    fontSize={"12px"}
                    color={"#475467"}
                    lineHeight={"18px"}
                    fontWeight={500}
                  >
                    {item}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isFetching || !data ? (
            <TableLoadingSkeleton rowsLength={15} cellsLength={8} />
          ) : (
            <TableBody>
              {data.data.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.reference}</TableCell>
                  <TableCell align="center">{row.branch?.name}</TableCell>
                  <TableCell align="center">{row.supplier?.name}</TableCell>
                  <TableCell align="center">{row.items_count}</TableCell>
                  <TableCell align="center">{row.items_total}</TableCell>
                  <TableCell align="center">
                    <SecondaryChip
                      label={row.status}
                      variant={
                        row.status === "Received"
                          ? "success"
                          : row.status === "cancelled"
                          ? "error"
                          : row.status === "Not Received"
                          ? "info"
                          : "warning"
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    {row.send_method === "email"
                      ? inventoryT("sentEmail")
                      : row.send_method === "app"
                      ? inventoryT("sentApp")
                      : inventoryT("notSent")}
                  </TableCell>

                  <TableCell align="center">
                    <TableActions row={row} refetch={refetch} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {emptyDataArr && <NoData />}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />
    </Stack>
  );
};
export default EntriesList;
